<template>

  <AppHeaderDropdown right no-caret>


    <template slot="header">
      <img src="img/avatars/8.jpg" class="img-avatar" alt="admin@bootstrapmaster.com" />

    </template>\
    <template slot="dropdown">
           <!-- Modal Component -->
   
     <!--  <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item><i class="fa fa-bell-o" /> Updates
        <b-badge variant="info">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-envelope-o" /> Messages
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-tasks" /> Tasks
        <b-badge variant="danger">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-comments" /> Comments
        <b-badge variant="warning">{{ itemsCount }}</b-badge>
      </b-dropdown-item> -->
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>{{nombreUsuario}}</strong>
      </b-dropdown-header>
      <b-dropdown-item><i class="fa fa-user" /> Perfil</b-dropdown-item>
      <b-dropdown-item  v-b-modal.modalPrevent><i class="fa fa-wrench" /> cambiar contraseña</b-dropdown-item>
     <!--  <b-dropdown-item><i class="fa fa-usd" /> Payments
        <b-badge variant="secondary">{{ itemsCount }}</b-badge>
      </b-dropdown-item> -->
    <!--   <b-dropdown-item><i class="fa fa-file" /> Projects
        <b-badge variant="primary">{{ itemsCount }}</b-badge>
      </b-dropdown-item> -->
      <b-dropdown-divider />
   <!--    <b-dropdown-item><i class="fa fa-shield" /> Lock Account</b-dropdown-item> -->
      <b-dropdown-item v-on:click="salir"> <i class="fa fa-lock" /> Salir</b-dropdown-item>

      <!-- Modal Component -->

    <div>

</div>

    </template>



  </AppHeaderDropdown>



</template>



<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'



export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
       itemsCount: 42,
       nombreUsuario : "",
         name: '',
      names: []
     }
  },
  methods: {
    salir() {
      const self = this;
      this.$swal.fire({
        title: '¿Quieres salir?',
        text: "",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Si"
      })
      .then(result => {
        if (result.value) {
          localStorage.removeItem('token')
          let resultado = delete self.$axios.defaults.headers.common['Authorization'];
          this.$store.dispatch('logout');
          this.$router.push('/pages/login');
      } else {

        }
      })


        },
        cambiarContrasena: function(e) {
/*this.$refs.myModalRef.show();*/
          alert("Aqui");



        }
      },
   mounted(){

    //alert(this.$store.getters.user.ACTIVO);
//alert(this.$store.getters.user.API_KEY);
//alert(this.$store.getters.user.ACTIVO);

//alert(JSON.stringify(this.$store.getters.user.MENU));

if(this.$store.state.user.ACTIVO == true)
{

this.nombreUsuario=this.$store.state.user.USUARIO;

}else{

this.$router.push('/');

}




    }
}
</script>
